<script>
import { userService } from "../../../helpers/backend/user.service"
export default {
  data() {
    return {
      form: {
        id: null,
        name: "",
        username: "",
        email: "",
        phone_number: "",
        password: "",
        is_mobile: false,
      },
      busy: false,
      show: true,
      showDismissibleAlert: false,
      error: "",
      active: false,
    }
  },
  computed: {
    isUpdateState() {
      return this.form.id != null
    },
  },
  methods: {
    onSubmit(event) {
      event.preventDefault()
      this.busy = true
      userService.createOrUpdate(this.form).then(
        (data) => {
          if (data != null) {
            this.reset()
            this.$emit("refresh")
            this.showDismissibleAlert = true
            this.error = ""
            this.setActive(false)
          }
          this.busy = false
        },
        (error) => {
          this.showDismissibleAlert = true
          this.error =
            "Failed to Insert/Update Principle Type. Error : " + error
          this.busy = false
        }
      )
    },
    reset() {
      // Reset our form values
      this.form.id = null
      this.form.name = ""
      this.form.username = ""
      this.form.email = ""
      this.form.phone_number = ""
      this.form.password = ""
      this.form.is_mobile = false
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.showDismissibleAlert = false
      this.error = ""
      this.$nextTick(() => {
        this.show = true
      })
    },
    onReset(event) {
      event.preventDefault()
      this.setActive(false)
      this.reset()
    },
    setActive(b, outside_triger) {
      this.active = b
      if (outside_triger) return
      this.$emit("active_change", b)
    },
    initUpdate(id) {
      this.setActive(true)
      if(id != -1){
        this.$nextTick(() => {
          this.reset()
          this.$refs.name.$el.focus()
          this.busy = true
          userService.getById(id).then(
            (data) => {
              if (data.user != null) {
                this.form.id = data.user.id
                this.form.name = data.user.name
                this.form.username = data.user.username
                this.form.email = data.user.email
                this.form.phone_number = data.user.phone_number
                this.form.is_mobile = data.user.is_mobile
              } else {
                this.showDismissibleAlert = true
                this.error =
                  "Failed to get user type to update. Error : user not found"
              }
              this.busy = false
            },
            (err) => {
              this.showDismissibleAlert = true
              this.error = "Failed to get user type to update. Error : " + err
              this.busy = false
            }
          )
        })
      }
    },
    invokeCreate() {
      this.setActive(true)
    },
  },
};
</script>


<template>
  <div v-if="this.active">
    <b-alert
      :variant="error == '' ? 'success' : 'danger'"
      dismissible
      fade
      :show="showDismissibleAlert"
      @dismissed="showDismissibleAlert = false"
    >
      <div v-if="error != ''">
        {{ error }}
      </div>
      <div v-else>Success perform Insert/Update action</div>
    </b-alert>
    <div class="card">
      <div class="card-body">
        <div>
          <b-form @submit="onSubmit" @reset="onReset" v-if="show" ref="form">
            <b-overlay :show="busy" rounded="lg" opacity="0.6">
              <b-form-group
                id="input-group-name"
                label="Name :"
                label-for="input-name"
              >
                <b-form-input
                  id="input-name"
                  v-model="form.name"
                  type="text"
                  placeholder="Insert Name"
                  required
                  ref="name"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="input-group-username"
                label="Username :"
                label-for="input-username"
              >
                <b-form-input
                  id="input-username"
                  v-model="form.username"
                  type="text"
                  placeholder="Insert username or nickname"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="input-group-email"
                label="Email :"
                label-for="input-email"
              >
                <b-form-input
                  id="input-email"
                  v-model="form.email"
                  type="email"
                  placeholder="Insert email"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="input-group-phone-number"
                label="Phone Number :"
                label-for="input-phone-number"
              >
                <b-form-input
                  id="input-phone-number"
                  v-model="form.phone_number"
                  type="text"
                  placeholder="Insert phone number"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group
                v-if="!isUpdateState"
                id="input-group-password"
                label="Password :"
                label-for="input-password"
              >
                <b-form-input
                  id="input-password"
                  v-model="form.password"
                  type="password"
                  placeholder="Insert password"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="input-group-is-mobile"
                label="Mobile user ?"
                label-for="input-is-mobile"
              >
                <b-form-checkbox
                  id="input-is-mobile"
                  v-model="form.is_mobile"
                  required
                />
              </b-form-group>

              <b-button class="mr-2" type="submit" variant="primary">
                {{ isUpdateState ? "Update" : "Submit" }}
              </b-button>
              <b-button type="reset" variant="danger">Cancel</b-button>
            </b-overlay>
          </b-form>
        </div>
      </div>
    </div>
  </div>
  <!-- <div v-else>
    <b-form-group>
      <b-button variant="primary" @click="invokeCreate">Create new</b-button>
    </b-form-group>
  </div> -->
</template>



